import { dashboard } from "../../helpers/backend_helper";
import { getEndOfDayTimestamp, getStartOfDayTimestamp } from "../../helpers/formatDate";
import {
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_BY_REGION_SUCCESS,
  FETCH_BY_REGION_FAILURE,
  FETCH_BY_GUARD_SUCCESS,
  FETCH_BY_GUARD_FAILURE,
} from "./actionTypes";

export const fetchDashboardDetails = () => async (dispatch) => {
  const payload = {
    act: "dashboard",
    subact: "getTicketCounts",
    info: {},

  };

  try {
    const response = await dashboard(payload);
    if (response.data) {
      dispatch({
        type: FETCH_DASHBOARD_DATA_SUCCESS,
        payload: {
          data: response.data,
        },
      });
    } else {
      dispatch({
        type: FETCH_DASHBOARD_DATA_FAILURE,
        error: "No dashboard data found.",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_DASHBOARD_DATA_FAILURE,
      error: "Failed to fetch dashboard data. Please try again.",
    });
  }
};

export const fetchByRegion =
  (region = "", fromDate, toDate,incidentTypeId) =>
  async (dispatch) => {
    const payload = {
      act: "dashboard",
      subact: "byregion",
      info: {},
      filter: { regionName: region, fromDate:getStartOfDayTimestamp(fromDate), toDate:  getEndOfDayTimestamp(toDate), incidentTypeId },
    };

    try {
      const response = await dashboard(payload);
      if (response.data) {
        dispatch({
          type: FETCH_BY_REGION_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_BY_REGION_FAILURE,
          error: "No region data found.",
        });
      }
    } catch (error) {
     
    }
  };

export const fetchByGaurd =
  (guardName = "",fromDate,toDate) =>
  async (dispatch) => {
    const payload = {
      act: "dashboard",
      subact: "byguard",
      info: {},
      filter: { guardName: guardName?.trim(),fromDate:getStartOfDayTimestamp(fromDate), toDate:  getEndOfDayTimestamp(toDate)  },
    };

    try {
      const response = await dashboard(payload);
      if (response.data) {
        dispatch({
          type: FETCH_BY_GUARD_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_BY_GUARD_FAILURE,
          error: "No guard data found.",
        });
      }
    } catch (error) {
    
    }
  };
